import { forwardRef } from 'react'
import { cn } from '../../lib/utils'

export const Select = forwardRef(function Select({ label, error, hint, children, className, ...props }, ref) {
  return (
    <div className="flex flex-col gap-1.5">
      {label && <label className="text-sm font-medium text-gray-700">{label}</label>}
      <select
        ref={ref}
        className={cn(
          'w-full rounded-lg border bg-white px-3 py-2 text-sm text-gray-900 transition-colors',
          'focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/20',
          error
            ? 'border-red-400'
            : 'border-gray-200 hover:border-gray-300',
          className
        )}
        {...props}
      >
        {children}
      </select>
      {error && (
        <p className="text-xs text-red-500 flex items-center gap-1">
          <i className="ti ti-alert-circle text-sm" />
          {error}
        </p>
      )}
      {hint && !error && <p className="text-xs text-gray-400">{hint}</p>}
    </div>
  )
})
